// src/pages/StorePage.jsx
import React, { useState, useEffect, useMemo } from 'react';
import ProductCard from '../components/ProductCard';
// Reuse blog page styling or create specific store styles
// import './StorePage.css';

const StorePage = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // State for filtering - start with showing only '#shop' tagged items
    const [activeFilterTag, setActiveFilterTag] = useState('shop');

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch('/products.json'); // Fetch from the static file
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                setProducts(data || []);
            } catch (err) {
                console.error("Failed to fetch products:", err);
                setError(`Failed to load products: ${err.message}`);
                setProducts([]);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []); // Fetch only once on component mount

    // Memoized filtered products based on activeFilterTag
    const filteredProducts = useMemo(() => {
        if (!activeFilterTag) {
            return products; // Show all if no filter is active
        }
        const lowerCaseFilter = activeFilterTag.toLowerCase();
        return products.filter(p =>
            Array.isArray(p.tags) && p.tags.some(tag => tag.toLowerCase() === lowerCaseFilter)
        );
    }, [products, activeFilterTag]);

    // Basic filter UI (could be more sophisticated)
    const handleFilterChange = (tag) => {
        setActiveFilterTag(tag); // Set the tag to filter by, or null to clear
    };


    return (
        // Reuse blog page container/wrapper styles if applicable
        <div className="blog-page"> {/* Example reuse */}
            <div className="container">
                

                {/* Filter Controls */}
                <div style={{ marginBottom: '2rem', textAlign: 'center', display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <button
                        onClick={() => handleFilterChange('shop')}
                        className={`more-button ${activeFilterTag === 'shop' ? 'active' : ''}`} // Reuse button style, add active state if needed
                        style={activeFilterTag === 'shop' ? { backgroundColor: '#007BFF', color: '#fff'} : {}} // Basic active style
                    >
                        All Store Items (#shop)
                    </button>
                    <button
                        onClick={() => handleFilterChange('merch')}
                        className={`more-button ${activeFilterTag === 'merch' ? 'active' : ''}`}
                        style={activeFilterTag === 'merch' ? { backgroundColor: '#007BFF', color: '#fff'} : {}}
                    >
                        Merch (#merch)
                    </button>
                    <button
                        onClick={() => handleFilterChange('digital')}
                        className={`more-button ${activeFilterTag === 'digital' ? 'active' : ''}`}
                        style={activeFilterTag === 'digital' ? { backgroundColor: '#007BFF', color: '#fff'} : {}}
                    >
                        Digital (#digital)
                    </button>
                    <button
                        onClick={() => handleFilterChange(null)} // Button to clear filter
                        className={`more-button ${!activeFilterTag ? 'active' : ''}`}
                        style={!activeFilterTag ? { backgroundColor: '#007BFF', color: '#fff'} : {}}
                    >
                        Show All Types
                    </button>
                    {/* Add more filter buttons as needed */}
                </div>


                {/* Loading and Error States */}
                {loading && <div className="loader">Loading products...</div>} {/* Reuse loader style */}
                {error && <div className="error">{error}</div>} {/* Reuse error style */}

                {/* Product Grid/List */}
                {!loading && !error && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '2rem' }}>
                        {filteredProducts.length > 0 ? (
                            filteredProducts.map(product => (
                                <ProductCard key={product.id} product={product} />
                            ))
                        ) : (
                            <p style={{ gridColumn: '1 / -1', textAlign: 'center' }}>
                                No products found matching the filter "{activeFilterTag}".
                            </p>
                        )}
                    </div>
                )}
                {!loading && !error && products.length === 0 && (
                    <p style={{ textAlign: 'center' }}>No products available at the moment.</p>
                )}
            </div>
        </div>
    );
};

export default StorePage;